/* tslint:disable */
/* eslint-disable */

/**
 * Order processing status
 */
export enum OrderProcessingStatus {
  Placed = 'placed',
  Kitchen = 'kitchen',
  Ready = 'ready',
  ProcessingCancellation = 'processingCancellation',
  Completed = 'completed',
  Failed = 'failed',
  Canceled = 'canceled'
}
